import _$ from 'jquery';
import OrderIndex, { initOrderIndex } from './order-index';
import React from 'react';
import Swiper from 'swiper';
import 'swiper-thumbnails';
import Popper from 'popper.js';
import { functions } from 'lodash';
import {createRoot} from 'react-dom/client';

let $ = _$;

if (!window.$ && !window.jQuery)
    window.$ = window.jQuery = $;
else {
    $ = window.$ || window.jQuery;
    window.$ = window.jQuery = $;
}

require('imagesloaded');
require('jquery-form');
$.fn.ajaxForm = _$.fn.ajaxForm;
$.fn.ajaxSubmit = _$.fn.ajaxSubmit;
$.fn.ajaxFormUnbind = _$.fn.ajaxFormUnbind;

let Macy = require('macy');

require('magnific-popup');
// for set external window jquery
$.fn.magnificPopup = _$.fn.magnificPopup;
$.magnificPopup = _$.magnificPopup;

let enquire = require('enquire.js');
require('./plugins/jquery.nice-select.js');
// require('./plugins/swiper.thumbnails.js');
// require('./plugins/enquire.js');
require('./plugins/lightbox.js');
require('tooltipster');

let toastr = require('toastr');
window.toastr = toastr;

function blockPage(msg) {
    $.magnificPopup.open({
        items: {
            src: $('<div class="modal"></div>').html(msg),
            type: 'inline'
        },
        closeOnContentClick: false,
        showCloseBtn: false,
        closeOnBgClick: false,
    });
}

window.blockPage = blockPage;

function unblockPage() {
    $.magnificPopup.close();
}

window.unblockPage = unblockPage;

function loadingHtml() {
    return $('<div><img src="/img/loading.svg" alt=""></div>')
}

window.loadingHtml = loadingHtml;


var between = function (c, a, b) {
    // console.log('between', a, c, b)
    if (a <= c && c <= b) {
        return true;
    }
    return false;
};

function fbkEvent(eventName) {
    if (window.debug !== true) {
        // console.log('fbk pixel event', eventName);

        if (window.fbq) {
            fbq('track', eventName);
        }
    }

}

// yandex metrika reach goal
function reachGoal(goal, cb, params) {

    var yParams = params || {};

    // console.log('reach goal in metrika', goal);

    if (window.ym) {
        ym.reachGoal(goal, yParams, cb);
    } else {
        // console.error('!!! YANDEX METRIKA IS NOT DEFINED !!!');

        if (typeof cb === 'function') {
            cb();
        }
    }

    window.llg('reachGoal_' + goal, params);
}

window.reachGoal = reachGoal;

function setProductThumbsSwiperHeight() {
    var $container = $('.product__thumbs-container'),
        $mainHeight = $('.product__slider-img').height(),
        $containerPadding = 0,
        $containerHeight;
    $containerHeight = $mainHeight - $containerPadding;
    $container.css('height', $containerHeight + 'px');
}

function initSelect() {
    $('.select').niceSelect();
}

function productSwiper() {

    var $productMainSwiper,
        $productThumbSwiper,
        $sliderSlides = $('.product__slider-img').length,
        $thumbsSlides = $('.product__thumbs-img').length;

    if ($sliderSlides === $thumbsSlides && $sliderSlides >= 1) {

        let initProductSwiper = function (instance) {

            setProductThumbsSwiperHeight();

            $productThumbSwiper = new Swiper('.product__thumbs-container', {
                speed: 500,
                spaceBetween: 4,
                slidesPerView: 3,
                // onlyExternal: true,
                direction: 'vertical',
                resizeReInit: true,

                navigation: {
                    prevEl: '.product__thumbs-prev',
                    nextEl: '.product__thumbs-next'
                },
            });

            $productMainSwiper = new Swiper('.product__slider-container', {
                speed: 500,
                onlyExternal: true,
                onInit: function (swiper) {
                    $productThumbSwiper.update(true);
                }
            });

            if ($thumbsSlides >= 5) {
                $('.product__thumbs-prev, .product__thumbs-next').addClass('is-active');
            }

            swiperThumbs($productMainSwiper, {
                element: 'product__thumbs-wrap',
                activeClass: 'is-active'
            });

        };

        // $('.product__gallery').imagesLoaded().always(initProductSwiper);
        initProductSwiper();

        // Product Zoom
        // $('.product__slider-link').each(function() {
        // 	var $big = $(this).attr('data-zoom')
        // 	$(this).zoom({
        // 		url: $big
        // 	});
        // });
        // $('.product__slider-link').zoom();


    }
}

function lookSwiper() {

    // $('.look-slider__container').imagesLoaded(function(){
    new Swiper('.look-slider__container', {
        loop: false,
        speed: 500,
        slidesPerColumn: 2,
        navigation: {
            prevEl: '.look-slider__prev',
            nextEl: '.look-slider__next',
        },
        // autoHeight: true,
        slidesPerView: 3,
        // centeredSlides: true,
        spaceBetween: 10,
        // loadPrevNext: true,
        preloadImages: false,
        // lazy: true,
        breakpoints: {
            580: {
                slidesPerView: 2,
            },

        },
        on: {
            slideChange: function () {
                // fix bug with first slide not load
                // this.lazy.loadInSlide(this.activeIndex - 1);
            }
        }
    });
    // })


}

$.fn.scrollTo = function () {
    var el = $(this);
    var offset = el.offset().top;
    $('body, html').animate({ 'scrollTop': offset }, 500);
};

function initJsAjax(root) {
    $(root).find('.js-ajax').magnificPopup({
        type: 'ajax',
        overflowY: 'scroll',
        closeMarkup: '<div class="modal__close mfp-close"></div>',
        removalDelay: 200,
        preloader: true,
        midClick: true,
        callbacks: {
            open: function () {
                $('.mfp-content').html('<div class="magnific-loading">Загрузка...</div>');
                $('.support').css('opacity', 0);
                $('.mfp-content').css({ 'max-width': '1024px' });
            },
            ajaxContentAdded: function () {
                productSwiper();
                initSelect();
                $('.mfp-content').find('.magnific-loading').remove();
            },
            close: function () {
                $('.support').css('opacity', 1);
            },
        }
    });
}

window.initJsAjax = initJsAjax;

$.fn.ajaxifiseForm = function (options) {

    if ($(this).length === 0) {
        return;
    }

    options = options || {};
    var idPrefix = options.idPrefix || '';
    var success = options.success || null;

    var container = $(this);
    var form = container;
    var success = options.success;

    if (form[0].tagName !== 'FORM') {
        form = container.find('form');
    }

    // form.ajaxFormUnbind();
    // form.off('submit');
    form.ajaxForm({
        'beforeSubmit': function () {
            // console.log('before submit');
            form.find('.disable-process-btn').attr('disabled', true);
        },
        'success': function (data) {

            form.find('.disable-process-btn').attr('disabled', false);
            form.find('.errors').remove('');

            if (data.status && data.status === 'fail') {
                if (data.errors) {
                    let errStr = [];

                    for (let k in data.errors) {
                        var fieldErrStr = data.errors[k].join(',');
                        errStr.push(fieldErrStr);

                        var input = $('#' + idPrefix + k);
                        var errorsTag = input.siblings('.errors');

                        if (errorsTag.length === 0) {
                            input.after('<div class="errors"></div>');
                            errorsTag = input.siblings('.errors');
                        }

                        errorsTag.html(fieldErrStr)
                    }

                    form.find('.errors-summary').html(errStr.join('<br>'))
                }
            }

            if (data.status && data.status === 'ok') {

                if (data.message) {
                    toastr.success(data.message);
                }

                if ($.modal !== undefined)
                    $.modal.close();

                if (success !== null) {
                    success(data)
                }

                if (data.redirect) {
                    window.location = data.redirect;
                }

                if (data.clear) {
                    // console.log('todo: clear form')
                }
            }

        }
    });
};

/**
 * Добавление товара в корзину через check
 * @param product_id
 * @param product_size_id
 */
function addProductToCart(product_id, product_size_id) {
    if (product_size_id === null || product_size_id === undefined || product_size_id === '') {
        window.toastr.error('Вы должны выбрать размер');
        return;
    }

    var request = {
        product_id: product_id,
        size_id: product_size_id
    };

    function _addToCart() {
        $.get('/site/add-to-cart/', request, function (response) {
            reachGoal('ADD_TO_CART', null, request);
            fbkEvent('ADD_TO_CART');

            if (response.success) {
                window.toastr.success('Вы добавили товар в корзину!' + '<div><a href="/order/index/" class="button">Перейти в корзину</a></div>');
            } else {
                window.toastr.error(response.message);
            }
        });
    }

    $.get('/site/add-to-cart-check/', request, function (response) {
        if (response.modal === true) {
            $.magnificPopup.open({
                items: {
                    src: response.html,
                    type: 'inline'
                }
            });

            $('.modal__product-set').find('.add-all-products-from-set').click(function (e) {
                e.preventDefault();
                _addToCart();
                $.magnificPopup.close();
            });
        } else {
            _addToCart();
        }
    });
}

window.addProductToCart = addProductToCart;

// Slider Swiper
$(document).ready(function () {
    (function () {
        var $slideCurrent = 0;
        var $sliderSwiperOffset = -0.5;
        var $sliderSwiperEffect = {
            onProgress: function (swiper, progress) {
                for (var i = 0; i < swiper.slides.length; i++) {

                    var $sliderSlide = swiper.slides[i];
                    var $sliderTranslate,
                        $sliderInnerTranslate;

                    progress = $sliderSlide.progress;

                    if (progress > 0) {
                        $sliderTranslate = progress * swiper.width;
                        $sliderInnerTranslate = $sliderTranslate * $sliderSwiperOffset;
                    } else {
                        $sliderInnerTranslate = Math.abs(progress * swiper.width) * $sliderSwiperOffset;
                        $sliderTranslate = 0;
                    }

                    // if (i == 0) {
                    // 	console.log(progress + ' <- progress');
                    // }

                    $($sliderSlide).css({
                        transform: 'translate3d(' + $sliderTranslate + 'px,0,0)'
                    });

                    $($sliderSlide).find('.slider__element').css({
                        transform: 'translate3d(' + $sliderInnerTranslate + 'px,0,0)'
                    });
                }
            },
            onSetTransition: function (swiper, speed) {
                for (var i = 0; i < swiper.slides.length; i++) {
                    $(swiper.slides[i])
                        .find('.slider__element')
                        .add($(swiper.slides[i]))
                        .css({
                            'transition': 'transform ' + speed + 'ms'
                        });
                }
            },
            onSlideChangeStart: function (swiper) {
                $('.slider__container .swiper-wrapper').addClass('is-sliding');
            },
            onSlideChangeEnd: function (swiper) {
                $('.slider__container .swiper-wrapper').removeClass('is-sliding');
            }
        };
        var $sliderOptions = {
            onlyExternal: true,
            noSwiping: true,
            allowTouchMove: false,

            loop: true,
            speed: 500,
            autoplay: 8000,
            // simulateTouch: false,
            watchSlidesProgress: true,
            // prevButton: '.slider__prev',
            // nextButton: '.slider__next',
            pagination: '.slider__count',
            // paginationType: 'fraction',
            // paginationFractionRender: function (swiper, currentClassName, totalClassName) {
            //     return '<div class="slider__count-current ' + currentClassName + '"></div>' +
            //            '<div class="slider__count-slash"></div>' +
            //            '<div class="slider__count-total ' + totalClassName + '"></div>';
            paginationType: 'custom',
            paginationCustomRender: function (swiper, current, total) {
                return '<div class="slider__count-current">' + current + '</div>' +
                    '<div class="slider__count-slash"></div>' +
                    '<div class="slider__count-total">' + total + '</div>';
            },
            preloadImages: false,
            lazy: true,
        };
        $sliderOptions = $.extend($sliderOptions, $sliderSwiperEffect);
        var $sliderMediumDetails = new Swiper('.slider__medium .slider__details', $sliderOptions);
        var $sliderMediumImage = new Swiper('.slider__medium .slider__img', $sliderOptions);
        var $sliderSmallDetails = new Swiper('.slider__small .slider__details', $sliderOptions);
        var $sliderSmallImage = new Swiper('.slider__small .slider__img', $sliderOptions);

        $('.slider__prev').click(function () {
            $sliderMediumDetails.slidePrev();
            $sliderMediumImage.slidePrev();
            $sliderSmallDetails.slidePrev();
            $sliderSmallImage.slidePrev();
        });
        $('.slider__next').click(function () {
            $sliderMediumDetails.slideNext();
            $sliderMediumImage.slideNext();
            $sliderSmallDetails.slideNext();
            $sliderSmallImage.slideNext();
        });
    })();
});

function navReset() {
    $('.nav__icon').removeClass('is-active');
    $('.nav__list').removeClass('is-active');
    $('.header__nav').removeClass('is-active');
}

function navDropdownReset() {
    $('.subnav').css('height', '');
    $('.subnav').css('opacity', '');
    $('.subnav').removeClass('is-active');
    $('.subnav__list').removeClass('is-active');
    $('.nav__link').removeClass('is-active');
    $('.nav__item-in').removeClass('is-active');
}

window.LeftSide = {
    clickOverlay: function () {
        LeftSide.hide();
        $('.page-overlay').off('click', this.clickOverlay);
    },
    show: function () {
        $('.left-side').addClass('active');
        $('.page-overlay').addClass('active');
        $('.page-overlay').on('click', this.clickOverlay);
    },
    hide: function () {
        $('.left-side').removeClass('active');
        $('.page-overlay').removeClass('active');
    }
};

// Mobile Navigation
$(document).ready(function () {
    // Mobile Navigation
    $('.nav__icon').click(function () {
        if ($('.nav__icon').hasClass('is-active')) {
            navReset();
            navDropdownReset();

            LeftSide.hide();
        } else {
            $('.nav__icon').addClass('is-active');
            $('.nav__list').addClass('is-active');
            $('.header__nav').addClass('is-active');

            LeftSide.show();
        }
    });

    $('.click-categories').on('click', function () {
        LeftSide.show();
    })

    $('.nav__list a:not(.nav__link--subnav)').click(function () {
        navReset();
        navDropdownReset();
    });

    // Mobile Navigation Dropdown
    $('.nav__item.has-subnav .nav__link').click(function (e) {
        if (window.matchMedia('(max-width: 1199px)').matches) {
            e.preventDefault();
        }
        var $icon = $(this),
            $holder = $(this).closest('.nav__item').find('.subnav'),
            $holderIn = $(this).closest('.nav__item').find('.nav__item-in'),
            $container = $holder.find('.subnav__list'),
            $height = $container[0].scrollHeight;
        if ($icon.hasClass('is-active')) {
            if (window.matchMedia('(max-width: 767px)').matches) {
                $holder.animate({
                    height: 0,
                    opacity: 0
                }, 200);
            }
            $icon.removeClass('is-active');
            $holder.removeClass('is-active');
            $holderIn.removeClass('is-active');
            $container.removeClass('is-active');
        } else {
            navDropdownReset();
            if (window.matchMedia('(max-width: 767px)').matches) {
                $holder.animate({
                    height: $height + 'px',
                    opacity: 1
                }, 200);
            }
            if (window.matchMedia('(max-width: 1199px)').matches) {
                $icon.addClass('is-active');
                $holder.addClass('is-active');
                $holderIn.addClass('is-active');
                $container.addClass('is-active');
            }
        }
    });
    $(document).click(function (e) {
        if (!$(e.target).closest('.nav__list, .nav__icon').length) {
            navReset();
            navDropdownReset();
        }
    });


});

// product swiper
$(document).ready(function () {
    // Product Swiper
    productSwiper();
});

// Ready
$(function ($) {
    let $windowWidth = $(window).width();

    // Select
    initSelect();

    // Dropdown
    function t(t) {
        $(t).bind('click', function (t) {
            t.preventDefault();
            // $(this).parent().fadeOut();
        })
    }

    $('.is-dropdown-toggle').click(function () {
        var t = $(this).parents('.has-dropdown').children('.is-dropdown').hasClass('is-active');
        $('.has-dropdown .is-dropdown').removeClass('is-active');
        $('.has-dropdown .is-dropdown-toggle').removeClass('is-active');
        if (!t) {
            $(this).parents('.has-dropdown').children('.is-dropdown').addClass('is-active').parents('.has-dropdown').children('.is-dropdown-toggle').addClass('is-active');
        }
    });
    $('.is-dropdown a').click(function () {
        $('.has-dropdown .is-dropdown').removeClass('is-active');
        $('.has-dropdown .is-dropdown-toggle').removeClass('is-active');
    });
    $(document).bind('click', function (t) {
        var dropdownTarget = $(t.target);
        if (!dropdownTarget.parents().hasClass('has-dropdown')) {
            $('.has-dropdown .is-dropdown').removeClass('is-active');
        }
    });
    $(document).bind('click', function (t) {
        var dropdownTarget = $(t.target);
        if (!dropdownTarget.parents().hasClass('has-dropdown')) {
            $('.has-dropdown .is-dropdown-toggle').removeClass('is-active');
        }
    });


    // Input Filled
    setTimeout(() => {
        $('input').blur(function () {
            if (!this.value) {
                $(this).removeClass('is-filled');
            } else {
                $(this).addClass('is-filled');
            }
        });
    });


    // Subnav Resize
    function subnavResize() {
        if (window.matchMedia('(min-width: 768px)').matches && window.matchMedia('(max-width: 1199px)').matches) {
            $('.subnav').css('width', ($('.nav').width() - $('.nav__list').width()) + 'px');
        } else {
            $('.subnav').css('width', '');
        }
    }

    setTimeout(() => {
        subnavResize();
    });


    // Filter Popper
    $('.filter__item').each(function () {
        setTimeout(() => {
            var $this = $(this),
                $filterPopperButton = $this.find('.filter__group'),
                $filterPopperElement = $this.find('.filter__popper');
            new Popper($filterPopperButton, $filterPopperElement, {
                modifiers: {
                    preventOverflow: {
                        priority: ['left', 'right', 'top']
                    },
                    flip: {
                        behavior: ['bottom']
                    },
                    offset: {
                        offset: -9
                    }
                }
            });
        })
    });

    $('.menu__item.has-dropdown').each(function () {
        setTimeout(() => {
            let dd = $(this).find('.menu__dropdown');
            dd.show();
            new Popper(this, dd[0], {
                modifiers: {
                    preventOverflow: {
                        priority: ['left', 'right', 'top']
                    },
                    flip: {
                        behavior: ['bottom']
                    },
                    offset: {
                        offset: -9
                    }
                }
            });
        });
    });


    // Filter Scroll
    // $('.filter__popper-scroll').jScrollPane({
    //     maintainPosition: false,
    //     verticalGutter: 0
    // });

    function filterPopperScrollToTop() {
        setTimeout(function () {
            // $('.filter__popper-scroll').each(function () {
            //     $(this).data('jsp').scrollToY(0);
            // });
        }, 200);
    }


    // Popper Dropdown
    $('.filter__group').click(function () {
        var t = $(this).parents('.filter__item').children('.filter__popper').hasClass('is-active');
        $('.filter__item .filter__popper').removeClass('is-active');
        $('.filter__item .filter__group').removeClass('is-active');
        if (!t) {
            $(this).parents('.filter__item').children('.filter__popper').addClass('is-active').parents('.filter__item').children('.filter__group').addClass('is-active');
        }
    });
    $('.filter__popper a').click(function () {
        $('.filter__item .filter__popper').removeClass('is-active');
        $('.filter__item .filter__group').removeClass('is-active');
        filterPopperScrollToTop();
    });
    $(document).bind('click', function (t) {
        var dropdownTarget = $(t.target);
        if (!dropdownTarget.parents().hasClass('filter__item')) {
            $('.filter__item .filter__popper').removeClass('is-active');
            filterPopperScrollToTop();
        }
    });
    $(document).bind('click', function (t) {
        var dropdownTarget = $(t.target);
        if (!dropdownTarget.parents().hasClass('filter__item')) {
            $('.filter__item .filter__group').removeClass('is-active');
            filterPopperScrollToTop();
        }
    });


    // Catalog Categories Toggle
    $('.categories__title').click(function (e) {
        var $link = $(this),
            $container = $('.categories__container'),
            $list = $('.categories__list'),
            $height = $list[0].scrollHeight;
        if (window.matchMedia('(max-width: 991px)').matches) {
            if ($link.hasClass('is-active')) {
                $container.animate({
                    height: 0,
                    opacity: 0
                }, 200);
                $link.removeClass('is-active');
                $container.removeClass('is-active');
                $list.removeClass('is-active');
            } else {
                $container.animate({
                    height: $height + 'px',
                    opacity: 1
                }, 200);
                $link.addClass('is-active');
                $container.addClass('is-active');
                $list.addClass('is-active');
            }
        }
    });
    $(document).click(function (e) {
        if (!$(e.target).closest('.categories__title, .categories__container').length) {
            categoriesToggleReset();
        }
    });

    function categoriesToggleReset() {
        $('.categories__container').css('height', '');
        $('.categories__container').css('opacity', '');
        $('.categories__title').removeClass('is-active');
        $('.categories__container').removeClass('is-active');
        $('.categories__list').removeClass('is-active');
    }

    // Modal
    $('.js-modal').magnificPopup({
        type: 'inline',
        overflowY: 'scroll',
        closeMarkup: '<div class="modal__close mfp-close"></div>',
        removalDelay: 200,
        preloader: false,
        midClick: true,
        callbacks: {
            open: function () {
                $('.support').css('opacity', 0);
            },
            close: function () {
                $('.support').css('opacity', 1);
            }
        }
    });

    initJsAjax(document);

    // Product Similar Swiper
    setTimeout(() => {
        $('.product__similar').imagesLoaded(function () {
            new Swiper('.product__similar-container', {
                speed: 500,
                spaceBetween: 24,
                slidesPerView: 2,
                navigation: {
                    prevEl: '.product__similar-prev',
                    nextEl: '.product__similar-next',
                },
                breakpoints: {
                    375: {
                        spaceBetween: 8,
                        slidesPerView: 2
                    },
                    544: {
                        slidesPerView: 3
                    },
                    768: {
                        spaceBetween: 16,
                        slidesPerView: 4
                    }
                }
            });
            if ($('.product__similar-slide').length >= 2) {
                $('.product__similar-prev, .product__similar-next').addClass('is-active');
            }
        });
    });

    setTimeout(() => {// Carousel Swiper
        $('.carousel__container').each(function () {

            var $this = $(this),
                $slides = $this.find('.carousel__slide').length,
                $prev = $this.closest('.carousel').find('.carousel__prev'),
                $next = $this.closest('.carousel').find('.carousel__next');

            $('.carousel__container').imagesLoaded(function () {
                new Swiper($this, {
                    speed: 500,
                    spaceBetween: 24,
                    slidesPerView: 5,

                    navigation: {
                        prevEl: $prev,
                        nextEl: $next,
                    },

                    breakpoints: {
                        375: {
                            spaceBetween: 8,
                            slidesPerView: 2
                        },
                        544: {
                            slidesPerView: 3
                        },
                        768: {
                            spaceBetween: 16,
                            slidesPerView: 4
                        },
                        992: {
                            spaceBetween: 16,
                            slidesPerView: 4
                        }
                    }
                });
            });

            if ($slides >= 2) {
                $prev.addClass('is-active');
                $next.addClass('is-active');
            }
        });
    });


    // Bag Qty
    setTimeout(() => {
        $('.bag__qty-button').click(function () {

            var $this = $(this),
                $input = $this.closest('.bag__item').find('.bag__qty-value'),
                $value = $input.val(),
                $newValue;

            if ($this.hasClass('bag__qty-plus')) {
                $newValue = parseFloat($value) + 1;
            }

            if ($this.hasClass('bag__qty-minus')) {
                if ($value >= 2) {
                    $newValue = parseFloat($value) - 1;
                } else {
                    $newValue = 1;
                }
            }

            $input.val($newValue);
        });
    });

    // Input Files
    setTimeout(() => {
        $('.form__file').each(function () {
            let $input = $(this);

            $input.on('change', function (e) {
                var $input = $(this);
                var textContainer = $input.parent().find('.form__inputfile-input');
                var initialText = textContainer.html();

                var $file = '';

                if (this.files && this.files.length > 1) {
                    $file = (this.getAttribute('data-multiple') || 'Несколько файлов');
                } else if (e.target.value) {
                    $file = e.target.value.split('\\').pop();
                }

                if ($file) {
                    textContainer.html($file);
                } else {
                    textContainer.html(initialText);
                }
            });

            // Firefox bug fix
            $input.on('focus', function () {
                $input.addClass('has-focus');
            }).on('blur', function () {
                $input.removeClass('has-focus');
            });
        });
    });

    if ($('#testimonials').length) {
        setTimeout(() => {
            var $testimonials = Macy({
                container: '#testimonials',
                waitForImages: false,
                trueOrder: false,
                margin: 0,
                columns: 2,
                breakAt: {
                    544: 1
                }
            });
        });
    }

    // Window Resize
    $(window).resize(function () {
        if ($(this).width() != $windowWidth) {
            $windowWidth = $(this).width();

            // Mobile Navigation Reset
            navReset();

            // Mobile Navigation Dropdown Reset
            navDropdownReset();

            // Subnav Resize
            subnavResize();

            // Catalog Categories Toggle Reset
            categoriesToggleReset();

            // Product Swiper Thumbs Height
            setProductThumbsSwiperHeight();

            // setCatalogDiscountButtonPosition();
        }
    });

    $(window).scroll(function () {
        if ($(window).scrollTop() > 100) {
            $('.scrollup').addClass('active');
        } else {
            $('.scrollup').removeClass('active');
        }
    });

    $('.scrollup').on('click', function () {
        $(window).scrollTop(0);
    });

    // Add to cart check for errors
    $(document).on('submit', '.form__add-to-cart', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $this = this;
        var action = $(this).attr('action');
        var data = $(this).serialize();
        $.get(action, data, function (data) {
            if (data.status === 'ok') {
                $(document).off('submit', '.form__add-to-cart');
                $this.submit();
            } else {
                alert(data.errors);
            }
        });
    });

    // var overlay = $('<div class="tooltip-popup__overlay"></div>');
    // $('body').append(overlay);
    // $(this).find('.tooltip-popup__text').fadeIn('fast');

    $('.tooltip-popup').each(function (i, e) {

        var img = $(this).find('img');

        var sourcePopupText = $(this).find('.tooltip-popup__text');
        var text = sourcePopupText.clone();
        sourcePopupText.remove();

        text.width(200);
        // console.log(text)

        var displayPresentText = function (e) {

            var overlay = $('<div class="tooltip-popup__overlay"></div>');
            var cloned = text.clone();
            var imgOffset = img.offset();

            var clonedOffsetLeft = imgOffset.left - 200
            clonedOffsetLeft = Math.abs(clonedOffsetLeft);

            cloned.css({
                left: clonedOffsetLeft,
                top: imgOffset.top
            });

            overlay.append(cloned);
            $('body').append(overlay);

            cloned.fadeIn('fast');

            var findPosition = function (event) {
                event.pageX + ", " + event.pageY;

                var xBetween = between(event.pageX, cloned.offset().left, imgOffset.left + img.outerWidth());
                var yBetween = between(event.pageY, cloned.offset().top, cloned.offset().top + cloned.outerHeight());

                if (!(xBetween && yBetween)) {
                    $(overlay).off('mousemove', findPosition);
                    overlay.remove();
                }
            }

            $(overlay).on('mousemove touch click', findPosition);
        }

        $(e).on('mouseenter touch click', displayPresentText);
    })


    $(document).ready(function () {
        // Text slider under main menu
        new Swiper('.text-slider', {
            direction: 'horizontal',
            loop: true,
            autoplay: 3000,
            autoHeight: true,
        })
    });

    lookSwiper();

    $('.accordion .item__heading').on('click', function () {
        var content = $(this).siblings('.item__content');

        if (!content.is(':visible')) {
            $('.accordion .item__content').slideUp('fast');
        }

        var $this = $(this);
        content.slideToggle('fast', function () {
            $this.scrollTo();
        });
    })

    // Каталог - кнопка показать больше на параметрах слева
    $('.side-show-more').click(function (e) {
        e.preventDefault();
        $(this).prev('ul').find('.hidden').show();
        $(this).remove();
    });

    $('.image-link').magnificPopup({ type: 'image' });

    $('.buy-one-click, .product__buy').on('click', function () {
        fbkEvent('ORDER_START_ONE_CLICK');
    });

    if (window.location.pathname.indexOf('/order/checkout') === 0) {
        fbkEvent('ORDER_START_CHECKOUT');
    }

    if (window.location.pathname.indexOf('/user/orders/view') === 0) {
        fbkEvent('ORDER_OVERVIEW_PAGE');
    }

    /**
     * Click on "create account" button (registration)
     */
    let createAccountBtn = $('.create-account-btn');
    let handleClickCreateAccount = (e) => {
        e.preventDefault();
        fbkEvent('CREATE_ACCOUNT');
        createAccountBtn.off('click', handleClickCreateAccount);
        setTimeout(() => {
            createAccountBtn.click();
        }, 500);
    };

    createAccountBtn.on('click', handleClickCreateAccount)
});


function addToFavorite(el) {
    var url = '/favorites/trigger';
    var id = $(el).attr('data-id');

    fbkEvent('ADD_TO_FAVORITE');

    $.get(url, { id: id }, function (data) {
        // console.log(data);
        if (data.status === 'created') {
            reachGoal('ADD_TO_FAVORITES');
            window.toastr.success('Добавлено');
        } else {
            window.toastr.warning('Удалено');
        }
        $(el).toggleClass('is-active');

    });
}

window.addToFavorite = addToFavorite;

function showNotFoundWhatYouWant() {
    if (window.sessionStorage && !window.sessionStorage.getItem('showNotFoundWhatYouWant')) {
        $('#open-callback-timeout').click();
        window.sessionStorage.setItem('showNotFoundWhatYouWant', 1);
    }
}

window.showNotFoundWhatYouWant = showNotFoundWhatYouWant;

$(document).ready(function () {
    // if (uvd > 2) {
    //     /**
    //      * Всплывающие окошечко
    //      */
    //     setTimeout(function () {
    //         showNotFoundWhatYouWant();
    //     }, 20000);
    // }

    $('#subscribe-form').ajaxifiseForm({
        success: function () {
            reachGoal('MAILING')
        },
    });
});

function openInfoModal(title, text) {

    $('#common-modal').find('.title').html(title);
    $('#common-modal').find('.text').html(text);

    $.magnificPopup.open({
        items: {
            src: '#common-modal',
            type: 'inline'
        }
    });
}

function alertModal(msg) {
    $.magnificPopup.open({
        items: {
            src: $('<div class="modal"></div>').html(msg + '<div class="modal__close mfp-close"></div>'),
            type: 'inline'
        }
    });
}

function closeLastModal() {
    var modal = $.magnificPopup.instance;
    modal.close();
}

function lazyLoad(el) {
    const targets = $(el);

    const lazyLoad = (i, target) => {
        const io = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    const src = img.getAttribute('data-src');

                    img.setAttribute('src', src);
                    img.classList.add('fade');

                    observer.disconnect();
                }
            });
        });

        io.observe(target)
    };

    targets.each(lazyLoad);
}

lazyLoad($('img[data-src]').not('.not-lazy img'));

/* .look-slider */
function initTabSlider() {
    new Swiper('.tabs .active .look-slider__container', {
        loop: false,
        speed: 500,
        slidesPerColumn: 2,
        navigation: {
            prevEl: '.look-slider__prev',
            nextEl: '.look-slider__next',
        },
        slidesPerView: 3,
        spaceBetween: 10,
        preloadImages: false,
        breakpoints: {
            580: {
                spaceBetween: 5,
                slidesPerView: 2,
            },

        },
    });
}

initTabSlider();

document.querySelectorAll('[data-tabs-val]').forEach(item => {
    item.addEventListener('click', e => {
        if (!item.classList.contains('active')) {
            let tab = item.closest('.tabs');
            let val = item.dataset.tabsVal;

            tab.querySelectorAll('[data-tabs-val]').forEach(
                i => {
                    if (i.dataset.tabsVal == val) {
                        i.classList.add('active');
                    } else {
                        i.classList.remove('active');
                    }
                }
            )

            tab.querySelectorAll('[data-tabs-id]').forEach(
                i => {
                    if (i.dataset.tabsId == val) {
                        i.classList.add('active');
                    } else {
                        i.classList.remove('active');
                    }
                }
            );

            initTabSlider();
            // console.log(tab.querySelector('[data-tabs-id="'+val+'"]'));
        }
    });
});

/* end .look-slider */


/**
 * product relink slider
 */
$(document).ready(function () {
    $('.product-more').each((index, item) => {

        // console.log(item);
        $(item).imagesLoaded(function () {
            // console.log('init swiper');
            new Swiper(item, {
                speed: 500,
                spaceBetween: 4,
                slidesPerView: 4,
                // onlyExternal: true,
                direction: 'horizontal',
                // draggable: true,

                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    400: {
                        spaceBetween: 4,
                        slidesPerView: 2
                    },
                    544: {
                        spaceBetween: 4,
                        slidesPerView: 3
                    },
                    700: {
                        spaceBetween: 4,
                        slidesPerView: 4
                    }
                }
            });
        });
    })
});

/**
 * Клик по инпуту снизу формы товара
 */
$(document).ready(function () {
    $('.product-reviews__input').on('click', function () {
        // открыть модалку - форма заполнения отзыва
        $.get('/product/review', {
            id: $(this).data('id')
        }, function (data) {

            var modal = $("<div class='modal'/>").html(data);

            $.magnificPopup.open({
                items: {
                    src: modal,
                    type: 'inline'
                }
            });

            modal.ajaxifiseForm({
                'idPrefix': 'productreviewform-',
                success: () => {
                    window.location.reload();
                }
            });

        })
    })
});

(function () {
    let unmatch = function () {
        // console.log('unmatch');
        $('.product__relink').insertAfter('.product__gallery');
        $('.product__info').prepend($('.product__title-group'));
    };

    enquire.register('screen and (max-width: 767px)', {
        match: function () {
            $('.product__relink').insertAfter('.product__reviews');
            $('.product__title-group').insertBefore($('.product__gallery'));
        },
        unmatch: unmatch
    });
})();

$('.product-md').each(function () {
    let tm = null;
    let replaceSlider = $(this).find('.replace-slider');
    let id = $(this).data('id');
    let sliderLoaded = false;
    let images = $('');
    let $this = $(this);
    let hovered = false;

    let HoverFirstTime = function () {
        hovered = true;
        $this.off('mouseenter', HoverFirstTime);

        // console.log('loading slider')
        $.get('/product/get-catalog-slider/', { id: id }, (html) => {
            replaceSlider.replaceWith(html);


            let switchPhotos = () => {
                let slider = $(this).find('.product-md__slider');
                images = slider.find('img');
                let cnt = images.length;

                let current = 0;
                tm = setInterval(function () {
                    images.fadeOut('fast');
                    images.eq(current).fadeIn('fast');
                    current += 1
                    if (current > (cnt - 1)) {
                        current = 0;
                    }
                }, 1000)
            };

            let stopSwitch = () => {
                clearTimeout(tm);
                images.hide();
            }

            $this.hover(switchPhotos, stopSwitch)

            if (hovered) {
                switchPhotos();
            }
        })
    }

    $this.on('mouseenter', HoverFirstTime);
    $this.on('mouseleave', () => {
        hovered = false
    });
})

$(document).ready(function () {

    let filterUrl = window.location.href;

    if (filterUrl.indexOf('?') > -1) {
        filterUrl += '&filter=1';
    } else {
        filterUrl += '?filter=1';
    }

    let loaded = false;

    $('.catalog__filter-btn').on('click', () => {
        $('.catalog-aside').addClass('active');

        if (!loaded) {
            loaded = true;
            $.get(filterUrl, function (html) {
                $('.catalog-aside__filter').html(html);

                $('.afilter__group').on('click', function () {
                    $(this).closest('.afilter__item').toggleClass('active');
                })

                $('.catalog-aside__close').on('click', function () {
                    $('.catalog-aside').removeClass('active');
                })

                addEvtCollapse('.catalog-aside [data-toggle]');

            })
        }

    })

    let defineControlsPosition = () => {
        let placeholder = $('.catalog__controls--placeholder');
        if (placeholder.length > 0) {
            let scrollTop = $(window).scrollTop();
            let ph = $('.catalog__controls--placeholder').offset().top;
            let controls = $('.catalog__controls');
            if (scrollTop > ph) {
                if (!controls.hasClass('fixed')) {
                    controls.addClass('fixed');
                }
            } else {
                if (controls.hasClass('fixed')) {
                    controls.removeClass('fixed');
                }
            }
        }
    }

    $(window).on('scroll', function () {
        defineControlsPosition();
    })

    defineControlsPosition();
})

$(document).ready(function () {

    let filterUrl = window.location.href;

    if (filterUrl.indexOf('?') > -1) {
        filterUrl += '&filter=1';
    } else {
        filterUrl += '?filter=1';
    }

    let loaded = false;

    let defineControlsPosition = () => {
        let placeholder = $('.catalog__controls--placeholder');
        if (placeholder.length > 0) {
            let scrollTop = $(window).scrollTop();
            let ph = $('.catalog__controls--placeholder').offset().top;
            let controls = $('.catalog__controls');
            if (scrollTop > ph) {
                if (!controls.hasClass('fixed')) {
                    controls.addClass('fixed');
                }
            } else {
                if (controls.hasClass('fixed')) {
                    controls.removeClass('fixed');
                }
            }
        }
    }

    $(window).on('scroll', function () {
        defineControlsPosition();
    })

    defineControlsPosition();
})

$.fn.swiper = function (props = {}) {

    $(this).each(function (index, item) {

        new Swiper(item, props);
    })
}

$(document).ready(function () {
    $('.brands-slider').swiper({
        slidesPerView: 4,
        spaceBetween: 20,

        breakpoints: {

            700: {
                slidesPerView: 3,
                spaceBetween: 5,
            },

        },
        navigation: {
            prevEl: '.look-slider__prev',
            nextEl: '.look-slider__next',
        },
    });

    $('.start-discount-slider').swiper({
        autoplay: {
            delay: 2500,
        },
        spaceBetween: 100,
        navigation: {
            prevEl: '.look-slider__prev',
            nextEl: '.look-slider__next',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
    });

    $('.start-popular-categories').swiper({
        slidesPerGroup: 4,
        spaceBetween: 10,
        slidesPerView: 4,
        breakpoints: {
            500: {
                slidesPerGroup: 2,
                spaceBetween: 2,
                slidesPerView: 2
            },
            700: {
                slidesPerGroup: 3,
                spaceBetween: 3,
                slidesPerView: 3
            },
            900: {
                slidesPerGroup: 4,
                spaceBetween: 4,
                slidesPerView: 4
            }
        },
        navigation: {
            prevEl: '.look-slider__prev',
            nextEl: '.look-slider__next',
        },
    })

    $('.start-new-products').swiper({

        slidesPerGroup: 6,
        spaceBetween: 10,
        slidesPerView: 5,
        // slidesPerColumn: 2,
        breakpoints: {
            500: {
                slidesPerGroup: 2,
                spaceBetween: 2,
                slidesPerView: 2
            },
            700: {
                slidesPerGroup: 3,
                spaceBetween: 3,
                slidesPerView: 3
            },
            900: {
                slidesPerGroup: 4,
                spaceBetween: 4,
                slidesPerView: 4
            }
        },
        navigation: {
            prevEl: '.look-slider__prev',
            nextEl: '.look-slider__next',
        },
    })

})

$(document).ready(function () {
    $('.left-side [data-open-tab]').on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('href');
        $(id).show();

        setTimeout(() => {
            $(id).addClass('active');
        })

        $('.left-side__tab--main').hide();
    })

    $('.left-side  [data-tab-close]').on('click', function (e) {
        e.preventDefault();

        let alltabs = $(this).closest('.left-side__tab');
        alltabs.removeClass('active');
        setTimeout(() => {
            alltabs.not('.left-side__tab--main').hide()
        }, 500)

        $('.left-side__tab--main').show();
        $('.left-side__tab--main--hidden').hide();
    })
})

$(document).ready(function () {
    $('.menu__dropdown').css('display', 'block');
})

$(document).ready(function () {
    $('.left-side .with-search .icon').on('click', function () {
        $('.left-side__item--search').toggleClass('active');
    });
})

$(document).ready(function () {
    $('.article table').each(function () {
        // console.log('responsive table');
        $(this).wrap('<div class="responsive-table"></div>');
    })
});

/**
 * Ввод номера
 */
$(document).ready(function () {
    let loginBtn = $('#btn-login');

    loginBtn.on('click', function (e) {
        setTimeout(() => {
            e.target.disabled = true;
        });
    });
})

/**
 * Вход через телефон
 */
$(document).ready(function () {
    let confirm = $('.confirm-phone');
    let inputs = confirm.find('input[type="text"]');
    let parent = confirm.parent();
    let fe = parent.find('.form-error');

    let getCode = () => {
        let code = inputs.map((i, el) => $(el).val() || '');
        code = code.toArray().join('');
        return code;
    }

    let sendRequest = () => {

        fe.hide();

        $.post('/auth/confirm-phone', {
            [$('meta[name="csrf-param"]').attr('content')]: $('meta[name="csrf-token"]').attr('content'),
            code: getCode(),
        }, (data) => {
            if (data.error) {
                fe.html(data.error)
                fe.show();
                inputs.val('');
            } else {
                if (data.redirect) {
                    window.location = data.redirect;
                }
            }
        })
    }

    let inputsPaste = (input, phrase) => {
        phrase = phrase.trim();

        if (phrase.length === 6) {
            // asd1231
            [...phrase].forEach((c, index) => {
                $(inputs[index]).val(c);
            });

            sendRequest();
        } else if (phrase.length === 1) {
            $(input).val(phrase);
            let code = getCode();
            if (code.length === 6) {
                sendRequest();
            }
        }
    }

    inputs.on('keydown', function (event) {

        if (!event) {
            return;
        }

        if (event.ctrlKey) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        let keyCode = event.keyCode,
            key = event.key;

        if (key === 'Backspace') {
            this.value = '';
            let prevInput = $(this).prev('input');

            if (prevInput.length > 0) {
                prevInput.focus();
            } else {
                sendRequest();
            }
        }

        let valid = (keyCode > 47 && keyCode < 58) || (keyCode > 64 && keyCode < 91)

        if (valid) {
            $(this).val(key);
            let nextInput = $(this).next('input');

            if (nextInput.length > 0) {
                nextInput.val('');
                nextInput.focus();
            } else {
                sendRequest();
            }
        }
    })

    inputs.on('paste', function (e) {
        e.preventDefault();

        // let pasteText = window.clipboardData.getData('Text');


        let clipboardData = e.originalEvent.clipboardData || window.clipboardData;
        let pastedData = clipboardData.getData('Text');

        inputsPaste($(this), pastedData);
    })
})

$(document).ready(function () {
    if ($('.confirm-phone-single').length > 0) {
        let input = $('.confirm-phone-single input');
        let fe = $('.confirm-phone-single .form-error');
        let btn = $('.confirm-phone-single button');

        function sendCode() {
            fe.hide();

            let code = input.val();

            $.post('/auth/confirm-phone', {
                [$('meta[name="csrf-param"]').attr('content')]: $('meta[name="csrf-token"]').attr('content'),
                code,
            }, (data) => {
                if (data.error) {
                    fe.html(data.error)
                    fe.show();
                    input.val('');
                } else {
                    if (data.redirect) {
                        window.location = data.redirect;
                    }
                }
            })
        }

        let checkCodeAnSend = () => {
            let code = input.val();

            if (code && code.length === 6) {
                sendCode();
            }
        }

        input.on('keyup', function () {
            checkCodeAnSend();
        });

        btn.on('click', function (e) {
            e.preventDefault();
            sendCode()
        })

        checkCodeAnSend();
    }
})


let Share = {
    vk: function (link, title, description, img) {
        let url = 'http://vk.com/share.php?';
        url += 'url=' + encodeURIComponent(link);
        url += '&title=' + encodeURIComponent(title);
        url += '&description=' + encodeURIComponent(description);
        url += '&image=' + encodeURIComponent(img);
        url += '&noparse=true';
        Share.popup(url);
    },
    facebook: function (link, description) {
        let url = 'http://www.facebook.com/sharer.php?';
        url += 'u=' + encodeURIComponent(link);
        url += '&t=+' + encodeURIComponent(description);
        Share.popup(url);
    },
    twitter: function (link, title) {
        let url = 'http://twitter.com/share?';
        url += 'url=' + encodeURIComponent(link);
        url += '&text=' + encodeURIComponent(title);
        url += '&counturl=' + encodeURIComponent(link);
        Share.popup(url);
    },
    popup: function (url) {
        var left = Math.round(window.innerWidth / 2 - 650 / 2);
        window.open(url, '', 'left=' + left + ',top=0,toolbar=0,status=0,width=650,height=450');
    }
};

$(document).ready(function () {
    // Instagram Swiper
    $('.instagram').imagesLoaded(function () {
        let $instagramSwiper = new Swiper('.instagram__slider-container', {
            loop: true,
            speed: 500,
            spaceBetween: 8,
            slidesPerView: 6,
            navigation: {
                prevEl: '.instagram__slider-prev',
                nextEl: '.instagram__slider-next',
            },
            breakpoints: {
                375: {
                    slidesPerView: 2
                },
                544: {
                    slidesPerView: 3
                },
                768: {
                    slidesPerView: 4
                },
                992: {
                    slidesPerView: 5
                }
            }
        });
    });

    // Product MD Favorite
    $('.product-md .product-md__favorite').click(function (e) {
        e.preventDefault();
    });

    // Product MD View
    $('.product-md .product-md__view').click(function (e) {
        e.preventDefault();
    });

    let sharePopper;
    // Share Buttons
    $('.share').each(function () {
        let icon = $(this).find('.share__icon');
        let popup = $(this).find('.share__popup');
        let container = $(this);

        function clickOutside() {
            container.removeClass('active');
            $(document).off('click', clickOutside)
        }

        container.on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            if (container.hasClass('active')) {
                if (jQuery(e.target).closest(container).length) return;
                clickOutside();
            } else {

                container.addClass('active');
                setTimeout(() => {
                    sharePopper.update();
                }, 200);

                $(document).on('click', clickOutside)
            }
        });

        sharePopper = new Popper(icon[0], popup[0], {
            placement: 'bottom',
            modifiers: {
                flip: {
                    behavior: ['bottom', 'left', 'top']
                },
            },
        });
    })

});

$(document).ready(function () {
    $('link[rel="preload"]').attr('rel', 'stylesheet');
});

require('./modules/checkout');

$.fn.orderIndex = function () {
    const el = this[0];
    if (el) {
        let props = $(el).data();
        initOrderIndex(el, props);
    }
    return this;
};

/**
 * auth/confirm-phone
 * counter
 */
$(document).ready(function () {
    let counter = $('.phone-counter')

    if (counter.length > 0) {

        let interval = setInterval(() => {
            let now = parseInt(counter.text());

            if (now) {
                now--;
                counter.text(now);
            }

            if (now === 0) {
                clearInterval(interval);
                $('.request-password-again').remove();
            }
        }, 1000);
    }
});

/**
 * Decrement login phone counter
 */
(jQuery(() => {
    let pc = $('.phone-counter');

    if (pc.length) {
        let getCnt = () => {
            return parseInt(pc.text())
        }

        let dec = () => {
            let current = getCnt();

            if (current > 0) {
                setTimeout(() => {
                    current--;
                    pc.text(current);
                }, 1000)
            } else {
                $('.request-password-again').remove();
            }
        }

        dec();
    }
}))

$(() => {
    $('#control-sizes .c').each(function () {
        // console.log('click disabled size', this);
        let product_id = $(this).data('product');
        let element = $(this);
        let msg = $(this).attr('data-message');
        element.attr('title', msg).tooltipster();
        element.click(function () {
            $.get('/site/notify-appear-form/', { product_id: product_id }, function (response) {
                $.magnificPopup.open({
                    items: {
                        src: "<div class='modal'>" + response + "</div>",
                        type: 'inline'
                    }
                });
                $('.modal__product-set').find('.add-all-products-from-set').click(function (e) {
                    e.preventDefault();
                    _addToCart();
                    $.magnificPopup.close();
                })
            });
        })
    })
})

/**
 * Логирование клиентских ошибок
 * @param msg
 * @param url
 * @param line
 */
window.addEventListener('error', function (e) {
    let stacktrace = e.stack;

    if (!stacktrace && e.error) {
        stacktrace = e.error.stack;
    }

    let msg = e.message + ', ' + e.filename + ', ' + e.lineno + ':' + e.colno;

    if (stacktrace) {
        // console.log('Stacktrace: ' + stacktrace);
    }

    $.post('/site/client-error/', {
        url: window.location.href,
        msg: {
            message: e.message,
            file: e.filename,
            line: e.lineno,
            col: e.colno,
        },
        stacktrace,
    }, () => {
        // console.log('Problem was reported to site administrator');
    });
})

window.llg = function (action, params = {}) {
    // console.log('llg', action, params);
    $.get('/site/llg', { action, params })
}

$(document).ready(function () {
    window.llg('loaded');
})


/* collapse */

/**
 * 
 * @param {*} $query_string Добавляем событие клика для коллапсов
 * 
 */
function addEvtCollapse($query_string) {
    document.querySelectorAll($query_string).forEach(
        item => {
            const el = item.querySelector('[data-toggle-btn]');
            
            if (el) {
                el.addEventListener('click', () => {
                    let target = item.querySelector('.target');
                    let isOpen = isOpenCollapse(target);
                    if (isOpen) {
                        item.classList.add('collapse-show');
                    } else {
                        item.classList.remove('collapse-show');
                    }
                    toggleCollapse(target);
                });
            }
        }
    );
}

addEvtCollapse('[data-toggle]');


/* 
document.querySelectorAll('[data-toggle]').forEach(
    item => {
      item.querySelector('[data-toggle-btn]').addEventListener('click', () => {
        let target = item.querySelector('.target');
        let isOpen = isOpenCollapse(target);
        if(isOpen){
            item.classList.add('collapse-show');
        } else {
            item.classList.remove('collapse-show');
        }
        toggleCollapse(target);
      });
    }
);
*/

function toggleCollapse(target) {
    // console.log(target);
    // console.log(target.querySelector('.content'));
    let content = target.querySelector('.content');
    let isOpen = isOpenCollapse(target);

    if (!isOpen) {
        target.style.height = content.offsetHeight + 'px';
    }

    target.classList.add('collapsing');
    target.classList.remove('collapse', 'show');

    if (isOpen) {
        target.style.height = content.offsetHeight + 'px';
    } else {
        setTimeout(() => {
            target.style.height = '';
        })
    }

    setTimeout(() => {
        target.classList.remove('collapsing');
        target.classList.add('collapse');

        if (isOpen) {
            target.classList.add('show');
        }
    }, 350);
}

function isOpenCollapse(target) {
    return target.classList.contains('collapse') && !target.classList.contains('show');
}

/* end collapse */

// start banner change img

function screen_check() {
    $('.start_banner_slide').each(function (index, value) {
        if ($(window).width() > '991') {
            var image = $(this).attr('data-background-image');
            $(this).css('background-image', `url(${image})`);
        } else {
            var image = $(this).attr('data-background-image-sm');
            $(this).css('background-image', `url(${image})`);
        }
    });
}

screen_check();
$(window).on('resize', function () {
    screen_check();
});

// END start banner change img